export default import.meta.ROLLUP_FILE_URL_fTIkIz2DtJHxM9Ozz7HfQw